<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :is-valid="isModalValid"
    :loading="computedIsLoading"
    v-bind="computedDialogProps"
    @agree="agree"
  >
    <template #body>
      <v-col cols="12" v-if="isFetched">
        <!-- Inputs above list -->
        <template v-if="mainInputs.length > 0">
          <v-form v-model="isMainFormValid" ref="mainForm">
            <template v-for="(mainInput, idx) of mainInputs">
              <v-row
                no-gutters
                :key="idx"
                :class="mainInput.rowClasses ? mainInput.rowClasses.join(' ') : ''"
                align="center"
              >
                <v-col cols="auto" class="text-left pb-5 pl-4">
                  <span> {{ mainInput.title }}: </span>
                </v-col>
                <v-col style="max-width: 275px !important; margin-left: 100px">
                  <data-input
                    v-model="computedValue[mainInput.name]"
                    :data-type="mainInput.dataType"
                    :rules="mainInput.rules"
                  />
                </v-col>
              </v-row>
            </template>
          </v-form>
        </template>
        <!-- List headers -->
        <template v-if="listInputs.length > 0">
          <v-row no-gutters justify="center" align="center" class="py-6 border-bottom">
            <v-col
              class="column-title"
              :class="{ 'settings-col': listInput.name === 'settings' }"
              v-for="listInput of listInputs"
              :key="listInput.name"
            >
              <span>
                {{ listInput.title }}
              </span>
            </v-col>
          </v-row>
          <!-- New list element -->
          <v-form v-model="isListNewFormValid" ref="listNewForm">
            <v-row no-gutters justify="center" align="center" class="pt-6 border-bottom" style="min-height: 95px">
              <template v-for="listInput of listInputs">
                <v-col v-if="listInput.name === 'settings'" :key="listInput.name" class="settings-col pb-6">
                  <v-icon
                    :style="`cursor: ${isListNewFormValid ? 'pointer' : 'default'}`"
                    :color="isListNewFormValid ? 'success' : 'grey'"
                    @click="pushElement"
                  >
                    mdi-check
                  </v-icon>
                </v-col>
                <v-col v-else :key="listInput.name">
                  <data-input
                    class="px-5 py-0 ma-0"
                    v-model="newListElement[listInput.name]"
                    v-bind="listInput.dataInput"
                  />
                </v-col>
              </template>
            </v-row>
          </v-form>
          <!-- List elements -->
          <span v-for="(element, idx) of computedValue[elementsName]" :key="idx">
            <v-form v-model="isListFormValid" form="listForm">
              <v-row no-gutters align="center" class="border-bottom justify-space-between" style="min-height: 95px">
                <template v-if="element.isEditing">
                  <v-col
                    v-for="listInput of listInputs"
                    :key="listInput.name"
                    :class="{ 'settings-col': listInput.name === 'settings', 'pt-6': listInput.name !== 'settings' }"
                  >
                    <template v-if="listInput.name === 'settings'">
                      <v-icon
                        :color="isListFormValid ? 'success' : 'grey'"
                        @click="editElementAction(idx, true)"
                        :style="`cursor: ${isListFormValid ? 'pointer' : 'default'}`"
                      >
                        mdi-check
                      </v-icon>
                      <v-icon color="error" @click="editElementAction(idx, false)">
                        mdi-close
                      </v-icon>
                    </template>
                    <template v-else>
                      <data-input
                        class="px-5 py-0 ma-0"
                        v-model="element[listInput.name]"
                        v-bind="listInput.dataInput"
                      />
                    </template>
                  </v-col>
                </template>
                <template v-else>
                  <v-col
                    v-for="listInput of listInputs"
                    :key="listInput.name"
                    :class="{ 'settings-col': listInput.name === 'settings' }"
                  >
                    <template v-if="listInput.name === 'settings'">
                      <v-icon
                        @click="editElement(idx)"
                        :color="isAnyStatisticEditing ? '#bababa' : undefined"
                        :style="`cursor: ${isAnyStatisticEditing ? 'default' : 'pointer'}`"
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon
                        @click="deleteElement(idx)"
                        :color="isAnyStatisticEditing ? '#bababa' : undefined"
                        :style="`cursor: ${isAnyStatisticEditing ? 'default' : 'pointer'}`"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <template v-else>
                      <slot
                        :name="`listValue.${listInput.name}.value`"
                        v-bind="{ ...listInput, value: element[listInput.name] }"
                      >
                        {{ element[listInput.name] }}
                      </slot>
                    </template>
                  </v-col>
                </template>
              </v-row>
            </v-form>
          </span>
        </template>
      </v-col>
    </template>
  </main-large-dialog>
</template>
<script>
import DataInput from '@/components/DataInput';
import MainLargeDialog from '@/components/MainLargeDialog';
export default {
  name: 'MainListDialog',
  components: { DataInput, MainLargeDialog },
  props: {
    dialogProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    elementsName: {
      type: String,
      default: 'elements',
    },
    initGets: {
      type: Function,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
    listInputs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    mainInputs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    minListValuesLength: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    defaultDialogProps: {
      minBodyHeight: '55vh',
      dialogWidth: '80%',
      headerShadow: true,
      noPaddingsX: true,
      title: '',
    },
    isAnyStatisticEditing: false,
    isFetched: false,
    isListFormValid: false,
    isListLengthValid: false,
    isListNewFormValid: false,
    isMainFormValid: false,
    newListElement: {},
  }),
  computed: {
    computedIsLoading: {
      get() {
        return this.loading;
      },
      set(nV) {
        this.$emit('update:loading', nV);
      },
    },
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    computedDialogProps() {
      return { ...this.defaultDialogProps, ...this.dialogProps };
    },
    isModalValid() {
      if (this.isAnyStatisticEditing) {
        return false;
      }
      if (!this.isListLengthValid && this.minListValuesLength) {
        return false;
      }
      return Boolean(this.isMainFormValid || this.mainInputs.length < 1);
    },
  },
  methods: {
    async init() {
      if (!this.initGets) {
        this.isFetched = true;
        return;
      }
      try {
        await this.initGets();
        this.isFetched = true;
      } catch {
        this.isFetched = true;
      }
    },
    agree() {
      this.$emit('agree');
    },
    deleteElement(idx) {
      this.computedValue[this.elementsName].splice(idx, 1);
      const listLength = this.computedValue[this.elementsName]?.length || 0;
      this.isListLengthValid = listLength >= this.minListValuesLength;
      this.$forceUpdate();
    },
    editElement(idx) {
      const currentElement = JSON.parse(JSON.stringify(this.computedValue[this.elementsName][idx]));
      currentElement.copy = this.computedValue[this.elementsName][idx];
      currentElement.isEditing = true;

      this.$set(this.computedValue[this.elementsName], idx, currentElement);
      this.isAnyStatisticEditing = true;
      this.$forceUpdate();
    },
    editElementAction(idx, agree) {
      let currentStatistic = JSON.parse(JSON.stringify(this.computedValue[this.elementsName][idx]));
      if (agree) {
        if (!this.isListFormValid) {
          return;
        }
        delete currentStatistic.copy;
        delete currentStatistic.isEditing;
      } else {
        currentStatistic = currentStatistic.copy;
      }
      this.$set(this.computedValue[this.elementsName], idx, currentStatistic);
      this.isAnyStatisticEditing = false;
      this.$forceUpdate();
    },
    pushElement() {
      if (!this.isListNewFormValid) {
        return;
      }
      if (!this.computedValue[this.elementsName]) {
        this.computedValue[this.elementsName] = [];
      }
      this.computedValue[this.elementsName].push(this.newListElement);
      const listLength = this.computedValue[this.elementsName]?.length || 0;
      this.isListLengthValid = listLength >= this.minListValuesLength;
      this.newListElement = {};
      this.$refs?.listNewForm?.resetValidation();
    },
  },
  watch: {
    computedIsVisible: {
      immediate: true,
      handler(nV) {
        if (nV) {
          this.isListLengthValid = this.computedValue[this.elementsName]?.length >= this.minListValuesLength;
        }
      },
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.border-bottom {
  @include border(bottom, 1px);
}
.column-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
}
.settings-col {
  max-width: 125px;
}
</style>
